import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { dimGrey, lightBlack, outlineSeparator } from '../../../mainTheme';
import { parseDateToLocal } from '../../../shared/utils';
import { PharmacyPatient } from '../../../store/pharmacyPatients/pharmacyPatientsTypes';

interface PatientDetailTabProps {
  patient?: PharmacyPatient;
}

const Row: React.FC<{ label: string; value?: string | number | null }> = ({
  label,
  value,
}) => (
  <Box display="flex" flexDirection="column" gap="4px">
    <Typography
      sx={{
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.2px',
        color: dimGrey,
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '22px',
        letterSpacing: '0.2px',
        color: lightBlack,
      }}
    >
      {value === undefined || value === null || value === '' ? 'N/A' : value}
    </Typography>
  </Box>
);

const PatientDetailTab: React.FC<PatientDetailTabProps> = ({ patient }) => {
  return (
    <Box
      p="16px"
      borderRadius="8px"
      border={`1px solid ${outlineSeparator}`}
      display="flex"
      flexDirection="column"
      gap={2}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '18px',
          lineHeight: '24px',
          letterSpacing: '0.2px',
          color: lightBlack,
        }}
      >
        Patient detail
      </Typography>
      <Divider />
      <Box
        display="grid"
        gridTemplateColumns="repeat(2, minmax(0, 1fr))"
        gap={3}
      >
        <Row label="Patient Pharmacy ID" value={patient?.pharmacy_patient_id} />
        <Row
          label="Name"
          value={`${patient?.first_name || ''} ${patient?.last_name || ''}`.trim()}
        />
        <Row label="Age" value={patient?.age} />
        <Row label="City" value={patient?.city} />
        <Row label="State" value={patient?.state} />
        <Row
          label="Created"
          value={
            patient?.created_at
              ? parseDateToLocal(patient.created_at, 'MMM dd, yyyy')
              : 'N/A'
          }
        />
      </Box>
    </Box>
  );
};

export default PatientDetailTab;
